import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import thankYou from "../../Assets/images/thankyou.png";
import pdf from "../../Assets/images/pdf.png";
import doc from "../../Assets/images/xls.png";
import "./ThankYou.scss";
import { Col, Row } from "reactstrap";
import { MultiStepProgressBar } from "../../Components/Popup/MultiStepProgressBar";
import { Link } from "react-router-dom";
// import SuggestedCourseCard from "../../Components/ExamPreparationCards/SuggestedCourseCard";
import Button from "../../Components/Buttons/Button";
import { Rating } from "react-simple-star-rating";
import { getSettings } from "../../services/getSettings";
import { getCoursesRandomly } from "../../services/getCoursesRandomly";

const ThankYou = () => {
  const [settingData, setSettingData] = useState([]);
  const fetchSettingData = async () => {
    try {
      const res = await getSettings();
      setSettingData(res?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSettingData();
  }, []);

  const [courseSuggestedCourseData, setSuggestedCourseData] = useState([]);
  useEffect(() => {
    const fetchSuggestedCourseData = async () => {
      try {
        const response = await getCoursesRandomly();
        setSuggestedCourseData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchSuggestedCourseData();
  }, []);

  return (
    <>
      {/* <Navbar /> */}
      <div className="container my-5  pagelayout-custom">
        <div className="">
          <img
            src={thankYou}
            alt="thank you"
            className="img-fluid"
            style={{ width: "30%" }}
          />
        </div>
        <div className="thank-you-container">
          <h2 className="course-name">PSYC 456</h2>
          <h3 className="college-name">IIT University - Special Study Notes</h3>
          <p className="dec">
            ( Our Expert team is working on your Special Study Notes )
          </p>
          <hr />
          <h1 className="order-time">
            You will Receive Your Materials by 24 Hours
          </h1>
          <p className="dec">
            ( We will send the materials by your whatsapp Number or email
            address )
          </p>
        </div>
        <div className="progress-bar-line">
          <Row className="m-3 w-75">
            <Col className="align-self-center mb-5">
              <MultiStepProgressBar
                step={2}
                totalSteps={4}
                hasStepZero={true}
                stepTexts={["Step 1", "Step 2", "Step 3", "Step 4"]} // Optional
              />
            </Col>
          </Row>
        </div>
        <div className="order-contact">
          <div className="py-5">
            <h3 className="college-name">
              IIT University - Special Study Notes
            </h3>
            <div className="pdf-doc-container">
              <img src={pdf} alt="pdf" />
              <img src={doc} alt="doc" />
            </div>
            <h1 className="order-time">You Materials will be Updated soon!</h1>
            <h3 className="till-contact">
              Till that time please contact through our executive to regular
              track your materials.
            </h3>
            <div className="all-btn-container">
              <Link
                to={`mailto:${settingData?.contactEmail}`}
                className="text-decoration-none"
                target="_blank"
              >
                <button className="email-w-us">
                  <i
                    className="fa-regular fa-envelope"
                    style={{ color: "#fff" }}
                  ></i>
                  <span>Email us</span>
                </button>
              </Link>
              <Link
                className="text-decoration-none"
                to={`https://wa.me/91${settingData?.contactNumber}`}
                target="_blank"
              >
                <button className="chat-w-whatsapp">
                  <i
                    className="fa-brands fa-whatsapp"
                    style={{ color: "#fff" }}
                  ></i>
                  <span>Chat with us</span>
                </button>
              </Link>
              <Link
                className="rbt-btn btn-gradient btn-sm text-decoration-none"
                to="/"
              >
                Back To Homepage
              </Link>
            </div>
          </div>
        </div>
        <hr className="my-5" />
        {/* <SuggestedCourseCard /> */}
        <div className="row">
          <h3 className="my-5">
            Suggested Courses based on the document that you are currently
            viewing
          </h3>
          {courseSuggestedCourseData?.map((course, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 mb-4 d-flex justify-content-center"
              key={index}
            >
              <div className="suggestion-card">
                <div>
                  <div className="uni-name">
                    <p>
                      {" "}
                      {course?.courseName?.length > 15
                        ? `${course?.courseName.substring(0, 15)}...`
                        : course?.courseName}{" "}
                      <span>
                        (
                        {course?.university?.universityName?.length > 15
                          ? `${course.university?.universityName.substring(
                              0,
                              15
                            )}...`
                          : course?.university?.universityName}
                        )
                      </span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <div className="rating-stars">
                      <Rating
                        size={20}
                        initialValue={parseFloat(course?.rating)}
                        readonly
                      />
                    </div>
                    <div className="purchase-text">
                      <i className="fa-solid fa-cart-shopping pe-2"></i>
                      <span>{course?.purchases} Purchases</span>
                    </div>
                  </div>
                </div>
                <div>
                  <Link to={`/course/${course?.courseUrl}`}>
                    <Button
                      varient="linear-gradient-primary"
                      className="px-3 py-2 fs-5"
                      text={"View"}
                    ></Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ThankYou;
